import {Headers, Http, Response} from "@angular/http";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";

declare var ENV: any;

@Injectable()
export class ApiService {
    private apiBaseUrl: string = ENV.api.baseUrl;
    public static tokenName: string = 'auth_token';
    private baseUrl: string = '/';

    constructor(private http: Http){}

    public get(path: string, queryParams: Object = {}, contentType: string = 'application/x-www-form-urlencoded', tokenName: string = '') {
        
        tokenName = tokenName || ApiService.tokenName;
        queryParams['_format'] = 'json';
        let queryString = this.serializeObject(queryParams);
        if(!path) { return null; }

        if(queryString){ queryString = '?'+queryString; }

        let url = this.getApiUrl(path) + queryString;
        
        if(ENV.debug)
            console.log('Getting: ' + url);

        return this.http.get(url, { headers: this.getHeaders(contentType, tokenName) });
    }

    public post(path: string, body: Object = {}, contentType: string = 'application/json', tokenName: string = '') {
        tokenName = tokenName || ApiService.tokenName;
        let url = this.getApiUrl(path) + '?_format=json';

        if(ENV.debug)
            console.log('Posting: ' + url);

        return this.http.post(url, body, { headers: this.getHeaders(contentType, tokenName) });
    }

    private getApiUrl(path: string): string {
        return this.apiBaseUrl + path;
    }

    private serializeObject(obj: Object = { }):string {
        let str = [];
        for(let p in obj)
            if (obj.hasOwnProperty(p)) {
                if(typeof obj[p] == 'object') {
                    str.push(this.serializeArray(p, obj[p]));
                } else {
                    str.push(this.encodeURIKey(p) + "=" + this.encodeURIValue(obj[p]));
                }
            }
        return str.join("&");
    }

    private serializeArray(key:string, obj: Object):string {
        let ret = [];
        for(let p in obj) {
            if (obj.hasOwnProperty(p)) {
                ret.push(this.encodeURIKey(key)+'[]='+this.encodeURIValue(obj[p]));
            }
        }
        return ret.join('&');
    }

    private encodeURIKey(p: string): string {
        return encodeURIComponent(p);
    }

    private encodeURIValue(p: string): string {
        return encodeURIComponent(p);
    }

    public static extractData(res: Response): JSON {
        let body = res.json();

        if(res.headers) {
            let count = res.headers.get('x-total-count');
            if(count) {
                body['total']= count;
            }
        }

        return body || [];
    }

    public static handleError (error: any, returnOnFailure: boolean = false) {
        // In a real world app, we might use a remote logging infrastructure
        // We'd also dig deeper into the error to get a better message
        let errMsg = this.getErrorMessage(error, returnOnFailure);
        console.error(errMsg); // log to console instead

        // this is only for users who are logged in and have problems.. killl all sessions
        if (errMsg == 'This route can only be accessed by anonymous users.') {
            window.location.href = '/cms/deletesession.php';
        }

        return Observable.throw(errMsg);
    }

    private static getErrorMessage(error: any, returnOnFailure: boolean = false) {
        if(typeof error.json == 'function')
        {
            let err = error.json();

            if(err.detail)
            {
                return err.detail;
            }

            if(err.message)
            {
                return err.message;
            }

            if(err.title)
            {
                return err.title;
            }
        }

        if(error.message)
        {
            return error.message;
        }

        if(error.status)
        {
            return `${error.status} - ${error.statusText}`;
        }

        if(returnOnFailure)
        {
            return error;
        }

        return 'Server error';
    }

    private getHeaders(contentType: string = 'application/x-www-form-urlencoded', tokenName: string = ''): Headers
    {
        let headersObject = {};
        if(contentType)
        {
            headersObject['Content-Type'] = contentType;
        }
        if(ENV.api.auth)
        {
            headersObject['Authorization'] = 'Basic ' + contentType;
        }
        let headers = new Headers(headersObject);
        tokenName = tokenName || ApiService.tokenName;
        if(ApiService.readToken(tokenName)) {
            headers.append('X-CSRF-Token', ApiService.readToken(tokenName));
        }

        return headers;
    }

    public static isLoggedIn(): boolean {
        return !!ApiService.readToken();
    }

    public static readToken(tokenName: string = '') {
        tokenName = tokenName || this.tokenName;
        return localStorage.getItem(tokenName);
    }

    public static writeToken( token, tokenName: string = '' ) {
        tokenName = tokenName || this.tokenName;
        localStorage.setItem(tokenName, token);
    }

    public static eraseToken(tokenName: string = '') {
        tokenName = tokenName || this.tokenName;
        localStorage.removeItem(tokenName);
    }

    public static writeObjectToken( token, tokenName: string = '' ) {
        tokenName = tokenName || this.tokenName;
        localStorage.setItem(tokenName, JSON.stringify(token));
    }

    public static readObjectToken(tokenName: string = '') {
        tokenName = tokenName || this.tokenName;
        return JSON.parse(localStorage.getItem(tokenName));
    }
}




// WEBPACK FOOTER //
// D:/Documents/FTP/derma/dermabase.nl_backup/src/app/services/api.service.ts